import { gql } from '@apollo/client';

import { FragmentFinancingDetails } from '../pdp/financingDetails';

export const FragmentVehiclesPCP = gql`
  fragment FragmentVehiclesPCP on Query {
    vehicles(filter: $filter, sorting: $sorting, pager: $pager) {
      aggregation {
        count
        page
        limit
      }
      results {
        title
        added
        bodyColor
        consumption
        electricConsumption
        wltConsumption
        wltConsumptionElectric
        wltEmission
        emission
        engineType
        imageUrl
        fuelType
        isNew
        trim
        makeName
        mwst
        mileage
        modelName
        powerHp
        powerKw
        price
        id
        registeredIn
        vin
        vehicleCondition
        co2Class
        co2ClassDischargedBatteryWltp
        ...FragmentFinancingDetails
      }
    }
  }
  ${FragmentFinancingDetails}
`;
